import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Link, Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PATH } from 'src/features/navigation/utils/constants';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { ICON_MAP } from 'src/utils/constants';

export default function StatisticLayout() {
    return (
        <>
            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to={`/${PATH.STATISTICS}`}>
                    <FontAwesomeIcon icon={ICON_MAP.BACK} className="opacity-50" />
                    <FormattedMessage {...statisticMessages.backToAllStatistics} />
                </Link>
            </Button>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
}
